export default __webpack_public_path__ + "static/media/activate-flight.9d4a802e.svg";